export default __webpack_public_path__ + "static/N0264-b0ba83972e90017103fd9a8d6148239d.png";